export const copyIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2750_14907)">
      <path
        d="M13.4286 4H5.57143C4.70355 4 4 4.70355 4 5.57143V13.4286C4 14.2964 4.70355 15 5.57143 15H13.4286C14.2964 15 15 14.2964 15 13.4286V5.57143C15 4.70355 14.2964 4 13.4286 4Z"
        stroke="#494C4F"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 11H2.42857C1.64286 11 1 10.3571 1 9.57143V2.42857C1 1.64286 1.64286 1 2.42857 1H9.57143C10.3571 1 11 1.64286 11 2.42857V4"
        stroke="#494C4F"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2750_14907">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const copyMarkdownIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.84615 15C3.35652 15 2.88695 14.8156 2.54073 14.4874C2.1945 14.1592 2 13.7141 2 13.25V2.75C2 2.28587 2.1945 1.84075 2.54073 1.51256C2.88695 1.18437 3.35652 1 3.84615 1H10.3077L14 4.5V13.25C14 13.7141 13.8055 14.1592 13.4593 14.4874C13.1131 14.8156 12.6435 15 12.1538 15H3.84615Z"
      stroke="#494C4F"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 10.5V6.3C5 6.2039 5.12234 6.16312 5.18 6.24L7.92 9.89333C7.96 9.94667 8.04 9.94667 8.08 9.89333L10.82 6.24C10.8777 6.16312 11 6.2039 11 6.3V10.5"
      stroke="#494C4F"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </svg>
)

export const refreshIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2750_14947)">
      <path
        d="M1.29004 6C2.15059 3.10851 4.82914 1 8.00016 1C11.0062 1 13.5697 2.89485 14.5614 5.55531C14.6535 5.80239 14.5178 6.07103 14.2704 6.16231L12.0002 7"
        stroke="#494C4F"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M14.4204 10C13.5599 12.8915 10.8813 15 7.71029 15C4.70422 15 2.14072 13.1051 1.14903 10.4447C1.05693 10.1976 1.19267 9.92897 1.44006 9.83769L3.71029 9"
        stroke="#494C4F"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2750_14947">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
